import { useMemo } from 'react'
import { useRecurrencyAccess } from '@cannect/services/resources/recurrency/hooks'
import { PATIENT_SIDE_PANEL, SIDE_PANEL_MY_SUBSCRIPTIONS } from '../constants/patient'
import { CRO_AND_CRM_PROFESSIONAL_SIDE_PANEL, PROFESSIONAL_SIDE_PANEL } from '../constants/professional'
import { SIDE_PANEL_MY_ORDERS } from '../constants/shared'

type SidePanel = typeof PATIENT_SIDE_PANEL

// "Minhas assinaturas" logo depois de "Meus pedidos", só para quem tem ou teve
// assinatura (useRecurrencyAccess().showNavigation).
const withSubscriptions = (panel: SidePanel, showNavigation: boolean): SidePanel => {
  if (!showNavigation) return panel
  const ordersIndex = panel.findIndex((item) => item.title.label === SIDE_PANEL_MY_ORDERS.title.label)
  const at = ordersIndex >= 0 ? ordersIndex + 1 : panel.length
  return [...panel.slice(0, at), SIDE_PANEL_MY_SUBSCRIPTIONS, ...panel.slice(at)]
}

export const usePatientSidePanel = () => {
  const { showNavigation } = useRecurrencyAccess()

  return useMemo(() => withSubscriptions(PATIENT_SIDE_PANEL, showNavigation), [showNavigation])
}

// 010 (research R7): conta de profissional também assina, então o menu dela
// ganha "Minhas assinaturas" pela mesma regra do paciente.
export const useProfessionalSidePanel = (isCRMOrCRO: boolean) => {
  const { showNavigation } = useRecurrencyAccess()

  return useMemo(
    () => withSubscriptions(isCRMOrCRO ? CRO_AND_CRM_PROFESSIONAL_SIDE_PANEL : PROFESSIONAL_SIDE_PANEL, showNavigation),
    [isCRMOrCRO, showNavigation]
  )
}
